/**
 * When Julian last pressed Stop in each chat (30 Sep 2026). A request he stopped on purpose
 * never shows "no final answer came" — that would be a false alarm. Kept per device, and
 * survives a reload (localStorage, wrapped: it can be unavailable).
 */
import { create } from "zustand";

const KEY = "reputifly.stopMarks.v1";

function load(): Record<string, number> {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export const useStopMarks = create<{ at: Record<string, number> }>(() => ({ at: typeof window === "undefined" ? {} : load() }));

export function markStopped(companyId: string | null | undefined): void {
  if (!companyId) return;
  const at = { ...useStopMarks.getState().at, [companyId]: Date.now() };
  // Keep the newest 200 chats only.
  const trimmed = Object.fromEntries(Object.entries(at).sort((a, b) => b[1] - a[1]).slice(0, 200));
  useStopMarks.setState({ at: trimmed });
  try { localStorage.setItem(KEY, JSON.stringify(trimmed)); } catch { /* per-device convenience only */ }
}
